import React, { useState, useEffect } from 'react';
import {
  Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Typography, Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Select, MenuItem, FormControl, InputLabel, InputAdornment, IconButton, Snackbar, Alert
} from '@mui/material';
import { collection, doc, setDoc, query, where, onSnapshot, getDocs, deleteDoc, updateDoc, getDoc  } from 'firebase/firestore';
import { db, auth } from '../../firebase';
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[3],
  backgroundColor: theme.palette.background.paper,
  "&:hover": {
    boxShadow: theme.shadows[6],
  },
}));

const AddPriceCategory = ({ companyCode }) => {
  const [priceCategories, setPriceCategories] = useState([]);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [newCategory, setNewCategory] = useState({
    priceCategoryName: '',
    percentageIncrement: '',
    unitCode: ''
  });
  const [units, setUnits] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [openEditDialog, setOpenEditDialog] = useState(false);
const [selectedCategory, setSelectedCategory] = useState(null);
const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
const [itemToDelete, setItemToDelete] = useState(null);

const [snackbar, setSnackbar] = useState({
  open: false,
  message: "",
  severity: "success"
});

const toTitleCase = (str) => {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const handleOpenDeleteDialog = (category) => {
  setItemToDelete(category);
  setOpenDeleteDialog(true);
};

const handleDeleteCategory = async () => {
  try {
    await deleteDoc(doc(db, "priceCategories", itemToDelete.id));

    setOpenDeleteDialog(false);
    setItemToDelete(null);

    setSnackbar({
      open: true,
      message: "Price Category deleted successfully",
      severity: "success"
    });

  } catch (error) {
    console.error("Error deleting category:", error);

    setSnackbar({
      open: true,
      message: "Failed to delete category",
      severity: "error"
    });
  }
};


const handleEditOpen = (category) => {
  setSelectedCategory(category);
  setOpenEditDialog(true);
};

const handleUpdateCategory = async () => {

    let formattedName =
    selectedCategory.priceCategoryName.trim().charAt(0).toUpperCase() +
    selectedCategory.priceCategoryName.trim().slice(1);

    
   if (selectedCategory.priceCategoryName.trim().toLowerCase() === "standard price") {
    setSnackbar({
      open: true,
      message: "Standard is a reserved price category and cannot be used.",
      severity: "error"
    });
    return;
  }

  try {
    const docRef = doc(db, "priceCategories", selectedCategory.id);

    await updateDoc(docRef, {
      priceCategoryName: /*selectedCategory.priceCategoryName,*/formattedName,
      percentageIncrement: parseFloat(selectedCategory.percentageIncrement),
      unitCode: selectedCategory.unitCode,
      modifiedAt: new Date().toISOString(),
      modifiedBy: auth.currentUser?.uid || "unknown"
    });

    setOpenEditDialog(false);

    setSnackbar({
      open: true,
      message: "Price Category updated successfully!",
      severity: "success"
    });

  } catch (error) {
    console.error("Error updating category:", error);

    setSnackbar({
      open: true,
      message: "Failed to update category",
      severity: "error"
    });
  }
};
const getUnitName = (unitCode) => {
  const unit = units.find(u => u.unitCode === unitCode);
  return unit ? unit.name : "N/A";
};

const [companyName, setCompanyName] = useState("");



  useEffect(() => {
    if (!companyCode) {
      console.error('AddPriceCategory: No companyCode provided');
      return;
    }

  const fetchCompany = async () => {
  try {
    const docRef = doc(db, "companies", companyCode);
    const snap = await getDoc(docRef);

    if (snap.exists()) {
      const data = snap.data();
      setCompanyName(data.name || "N/A");
    }
  } catch (error) {
    console.error("Error fetching company:", error);
  }
};

     fetchCompany(); 
    /*const fetchUnits = async () => {
    try {
      const unitsQuery = query(
        collection(db, "units"),
        where("companyCode", "==", companyCode)
      );

      const snapshot = await getDocs(unitsQuery);

      const unitList = snapshot.docs.map(doc => ({
        unitCode: doc.id,
        name: doc.data().unitName || doc.id
      }));

      setUnits(unitList);

    } catch (error) {
      console.error("Error fetching units:", error);
    }
  };*/

  const fetchUnits = async () => {
  try {
    const unitsQuery = query(
      collection(db, "units"),
      where("companyCode", "==", companyCode)
    );

    const snapshot = await getDocs(unitsQuery);

    const unitList = snapshot.docs.map(doc => ({
      unitCode: doc.id,
      name: doc.data().unitName || doc.id
    }));

    setUnits(unitList);

    // Ensure Standard category exists
    await ensureStandardCategory(unitList);

  } catch (error) {
    console.error("Error fetching units:", error);
  }
};

  fetchUnits();


    const categoryQuery = query(
      collection(db, 'priceCategories'),
      where('companyCode', '==', companyCode)
    );


    const unsubscribe = onSnapshot(
      categoryQuery,
      (querySnapshot) => {
        const list = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));

        setPriceCategories(list);
      },
      (error) => {
        console.error('AddPriceCategory: Error fetching price categories:', error);
      }
    );

    return () => unsubscribe();
  }, [companyCode]);

  const ensureStandardCategory = async (unitList) => {
  try {
    for (const unit of unitList) {
      const q = query(
        collection(db, "priceCategories"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unit.unitCode),
        where("priceCategoryName", "==", "Standard Price")
      );

      const snapshot = await getDocs(q);

      // If not exists → create it
      if (snapshot.empty) {
        const docRef = doc(collection(db, "priceCategories"));

        await setDoc(docRef, {
          id: docRef.id,
          priceCategoryName: "Standard Price",
          percentageIncrement: 0,
          unitCode: unit.unitCode,
          companyCode,
          createdAt: new Date().toISOString(),
          createdBy: auth.currentUser?.uid || "system",
          modifiedAt: new Date().toISOString(),
          modifiedBy: auth.currentUser?.uid || "system"
        });

        console.log(`Standard category created for unit: ${unit.unitCode}`);
      }
    }
  } catch (error) {
    console.error("Error ensuring standard category:", error);
  }
};
  const handleOpenAddDialog = () => {
    setOpenAddDialog(true);
    setNewCategory({
  priceCategoryName: '',
  percentageIncrement: '',
  unitCode: ''
});
  };

  const handleCloseAddDialog = () => {
    setOpenAddDialog(false);
  };

  /*const handleChange = (e) => {
    const { name, value } = e.target;
    setNewCategory(prev => ({ ...prev, [name]: value }));
  };*/
  const handleChange = (e) => {
  const { name, value } = e.target;

 if (name === "priceCategoryName") {

  if (value.trim().toLowerCase() === "standard price") {
    setSnackbar({
      open: true,
      message: "Standard is reserved and cannot be used.",
      severity: "error"
    });
    return;
  }

  /*const formatted =
    value.trimStart().charAt(0).toUpperCase() +
    value.trimStart().slice(1);

  setNewCategory(prev => ({ ...prev, [name]: formatted }));*/

  setNewCategory(prev => ({ 
      ...prev, 
      [name]: toTitleCase(value) 
    }));

} else {
    setNewCategory(prev => ({ ...prev, [name]: value }));
  }
};

  const handleAddCategory = async () => {
    if (!newCategory.priceCategoryName || !newCategory.percentageIncrement || !newCategory.unitCode) {
  alert('Please enter category name, unit and percentage increment');
  return;
}

//Prevent Standard
  if (newCategory.priceCategoryName.trim().toLowerCase() === "standard price") {
    alert("Standard is a reserved price category and cannot be created.");
    return;
  }

    const incrementValue = parseFloat(newCategory.percentageIncrement);
    if (isNaN(incrementValue) || incrementValue < 0 || incrementValue > 100) {
      alert('Please enter a valid percentage between 0 and 100');
      return;
    }

    const currentUser = auth.currentUser;
    const userId = currentUser ? currentUser.uid : "unknown";

    try {
     /* const sanitizedName = newCategory.priceCategoryName.replace(/\s+/g, '_');
      const docId = `${companyCode}_${sanitizedName}`;
      const docRef = doc(db, 'priceCategories', docId);

      const existingDoc = await getDoc(docRef);
      if (existingDoc.exists()) {
        alert(`This price category name ${newCategory.priceCategoryName} already exists for the company.`);
        return;
      }*/
     const categoryQuery = query(
  collection(db, "priceCategories"),
  where("companyCode", "==", companyCode),
  where("priceCategoryName", "==", newCategory.priceCategoryName)
);

const snapshot = await getDocs(categoryQuery);

if (!snapshot.empty) {
  //alert(`Price category ${newCategory.priceCategoryName} already exists`);
  setSnackbar({
  open: true,
  message: `Price category ${newCategory.priceCategoryName} already exists`,
  severity: "error"
});
  return;
}
const docRef = doc(collection(db, "priceCategories"));


   await setDoc(docRef,  {
     id: docRef.id,
        priceCategoryName: newCategory.priceCategoryName,
        percentageIncrement: incrementValue,
         unitCode: newCategory.unitCode,
        companyCode,
        createdAt: new Date().toISOString(),
        //createdAt: serverTimestamp(),
  createdBy: userId,
  modifiedAt: new Date().toISOString(),
  modifiedBy: userId
      });

      setSnackbar({
  open: true,
  message: "Price Category added successfully!",
  severity: "success"
});

      console.log(`AddPriceCategory: Added Price Category with ID: ${docRef.id}, Name: ${newCategory.priceCategoryName}, Percentage: ${incrementValue}%`);
      handleCloseAddDialog();
    } catch (error) {
      console.error('AddPriceCategory: Error adding Price Category:', error);
      alert(`Failed to add price category: ${error.message}`);
    }
  };

  const filteredCategories = priceCategories.filter(category =>
  category.priceCategoryName
    ?.toLowerCase()
    .includes(searchTerm.toLowerCase())
);

  return (
    <Box sx={{ p: 4, bgcolor: 'background.default', position: 'relative' }}>
    <Typography
  variant="h4"
  sx={{ fontWeight: "bold", color: "text.primary", mb: 3 }}
>
  Price Category Master
</Typography>
<Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 3,
    mt:2
  }}
>
  <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb:1, mt:2}}>
    <Typography variant="h5" sx={{ fontWeight: "bold", color: "text.primary" }}>
      Price Category List
    </Typography>

    <TextField
      label="Search By Category Name"
      variant="outlined"
      size="small"
      sx={{ width: 300 }}
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  </Box>

  <Button
    variant="contained"
    onClick={handleOpenAddDialog}
    sx={{ borderRadius: "5px", textTransform: "none", px: 3, py: 1 }}
  >
    Add Price Category
  </Button>
</Box>

      <StyledCard>
  <TableContainer component={Paper} sx={{ bgcolor: "background.paper" }}>
        <Table>
          <TableHead>
           <TableRow sx={{ bgcolor: "background.default" }}>
            <TableCell sx={{ fontWeight: "bold" }}>Unit</TableCell>
             <TableCell sx={{ fontWeight: "bold" }}>Company</TableCell>
              <TableCell sx={{ color: "text.primary", fontWeight: "bold" }}>
  Price Category Name
</TableCell>

<TableCell sx={{ color: "text.primary", fontWeight: "bold" }}>
  Percentage Increment on Standard Price
</TableCell>

{/*<TableCell sx={{ color: "text.primary", fontWeight: "bold" }}>
  Created At
</TableCell>*/}

<TableCell sx={{ color: "text.primary", fontWeight: "bold" }}>
  Actions
</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
           {filteredCategories.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} align="center">
                    <Typography variant="body1" color="text.secondary">
                        No Price Categories available for this company.
                    </Typography>
                </TableCell>
              </TableRow>
            ) : (
              filteredCategories.map(category => (
               <TableRow key={category.id}>
                <TableCell>
    {getUnitName(category.unitCode)}
  </TableCell>
  <TableCell>
  {companyName}
</TableCell>
  <TableCell>{category.priceCategoryName}</TableCell>
  <TableCell>{category.percentageIncrement}%</TableCell>
  {/*<TableCell>{category.createdAt || 'N/A'}</TableCell>*/}

  <TableCell>
    {/*<IconButton
      color="primary"
      onClick={() => handleEditOpen(category)}
    >
      <EditIcon />
    </IconButton>
<IconButton
  color="error"
  onClick={() => handleOpenDeleteDialog(category)}
>
  <DeleteIcon />
</IconButton>*/}
{category.priceCategoryName !== "Standard Price" && (
  <>
    <IconButton
      color="primary"
      onClick={() => handleEditOpen(category)}
    >
      <EditIcon />
    </IconButton>

    <IconButton
      color="error"
      onClick={() => handleOpenDeleteDialog(category)}
    >
      <DeleteIcon />
    </IconButton>
  </>
)}
  </TableCell>
</TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
</StyledCard>
      <Dialog open={openAddDialog} onClose={(event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
           handleCloseAddDialog();
          }
        }}
      >
        <DialogTitle>Add Price Category</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            name="priceCategoryName"
            label="Price Category Name"
            fullWidth
            value={newCategory.priceCategoryName}
            onChange={handleChange}
          />
        <FormControl fullWidth margin="dense" sx={{ mt: 2, minWidth: 90 }}>
                     <InputLabel id="unit-select-label">Unit</InputLabel>
                     <Select
  labelId="unit-select-label"
  name="unitCode"
  value={newCategory.unitCode || ''}
  label="Unit"
  required
  onChange={handleChange}
  MenuProps={{ PaperProps: { style: { maxHeight: 90 } } }}
>
                       {units.length > 0 ? (
                         units.map(unit => (
                           <MenuItem key={unit.unitCode} value={unit.unitCode}>
                             {unit.name}
                           </MenuItem>
                         ))
                       ) : (
                         <MenuItem value="" disabled>
                           No units available
                         </MenuItem>
                       )}
                     </Select>
                   </FormControl>
          <TextField
            margin="dense"
            name="percentageIncrement"
            label="Percentage Increment on Standard Price"
            type="number"
            fullWidth
            value={newCategory.percentageIncrement}
            onChange={handleChange}
            inputProps={{ step: 0.01 }}
            helperText="Enter percentage (0-100)"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAddDialog}>Cancel</Button>
          <Button
            onClick={handleAddCategory}
            disabled={!newCategory.priceCategoryName || !newCategory.percentageIncrement}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openEditDialog}/* onClose={() => setOpenEditDialog(false)}*/
        onClose={(event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
           setOpenEditDialog(false)
          }
        }}>
  <DialogTitle>Edit Price Category</DialogTitle>

  <DialogContent>
    <TextField
      margin="dense"
      label="Price Category Name"
      fullWidth
      value={selectedCategory?.priceCategoryName || ""}
      /*onChange={(e) => {
  const value = e.target.value;
  const formatted =
    value.trimStart().charAt(0).toUpperCase() +
    value.trimStart().slice(1);

  setSelectedCategory({
    ...selectedCategory,
    priceCategoryName: formatted
  });
}}*/
 onChange={(e) => {
    const value = e.target.value;
    setSelectedCategory({
      ...selectedCategory,
      priceCategoryName: toTitleCase(value)
    });
  }}
    />

    {/* UNIT DROPDOWN */}
    <FormControl fullWidth margin="dense" sx={{ mt: 2 }}>
      <InputLabel>Unit</InputLabel>
      <Select
        value={selectedCategory?.unitCode || ""}
        label="Unit"
        onChange={(e) =>
          setSelectedCategory({
            ...selectedCategory,
            unitCode: e.target.value
          })
        }
      >
        {units.map((unit) => (
          <MenuItem key={unit.unitCode} value={unit.unitCode}>
            {unit.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>

    <TextField
      margin="dense"
      label="Percentage Increment"
      type="number"
      fullWidth
      value={selectedCategory?.percentageIncrement || ""}
      onChange={(e) =>
        setSelectedCategory({
          ...selectedCategory,
          percentageIncrement: e.target.value
        })
      }
    />
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenEditDialog(false)}>Cancel</Button>
    <Button onClick={handleUpdateCategory}>Update</Button>
  </DialogActions>
</Dialog>

<Dialog
  open={openDeleteDialog}
  onClose={() => setOpenDeleteDialog(false)}
  maxWidth="xs"
  fullWidth
>
  <DialogTitle>Confirm Delete</DialogTitle>

  <DialogContent>
    <Typography>
      Are you sure you want to delete "{itemToDelete?.priceCategoryName}"?
      This action cannot be undone.
    </Typography>
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenDeleteDialog(false)}>
      Cancel
    </Button>

    <Button
      onClick={handleDeleteCategory}
      color="error"
      variant="contained"
    >
      Delete
    </Button>
  </DialogActions>
</Dialog>
<Snackbar
  open={snackbar.open}
  autoHideDuration={3000}
  onClose={() => setSnackbar({ ...snackbar, open: false })}
  anchorOrigin={{ vertical: "top", horizontal: "right" }}
>
<Alert
  severity={snackbar.severity}
  variant="outlined"
  onClose={() => setSnackbar({ ...snackbar, open: false })}
  sx={{
    backgroundColor: "#fff",
    color: "#000",
    border: "1px solid #ddd",
    fontWeight: "bold",
    fontSize: "16px"
  }}
>
  {snackbar.message}
</Alert>
</Snackbar>
    </Box>
  );
};

export default AddPriceCategory;